import _Button from "antd/es/button";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { memo, useMemo } from 'react';
import ConditionalRender from '@baifendian/adhere-ui-conditionalrender';
import HistoryBack from '@baifendian/adhere-ui-historyback';
import Intl from '@baifendian/adhere-util-intl';
import ToolBarLayout from './ToolBarLayout';
/**
 * BackLayout
 * @class BackLayout
 * @classdesc BackLayout
 */
var BackLayout = /*#__PURE__*/memo(function (props) {
  var _a = props.topToolBarItems,
    topToolBarItems = _a === void 0 ? [] : _a,
    _b = props.isShowBack,
    isShowBack = _b === void 0 ? true : _b,
    _c = props.backPath,
    backPath = _c === void 0 ? '/' : _c,
    _d = props.enforceBackPath,
    enforceBackPath = _d === void 0 ? '' : _d,
    history = props.history,
    backTitle = props.backTitle,
    children = props.children,
    resetProps = __rest(props, ["topToolBarItems", "isShowBack", "backPath", "enforceBackPath", "history", "backTitle", "children"]);
  var toolbar = useMemo(function () {
    return __spreadArray(__spreadArray([], topToolBarItems || [], true), [/*#__PURE__*/React.createElement(ConditionalRender, {
      key: "backBtn",
      conditional: isShowBack
    }, function () {
      return /*#__PURE__*/React.createElement(_Button, {
        onClick: function () {
          if (enforceBackPath) {
            history.replace(enforceBackPath);
          } else {
            HistoryBack(history, backPath);
          }
        }
      }, backTitle || Intl.v('返回'));
    })], false).filter(function (t) {
      if ('props' in t && 'conditional' in t.props) return t.props.conditional;
      return true;
    });
  }, [topToolBarItems, isShowBack, enforceBackPath, backPath, backTitle]);
  return /*#__PURE__*/React.createElement(ToolBarLayout, __assign({}, resetProps, {
    topToolBarItems: toolbar
  }), children);
});
BackLayout.displayName = 'BackLayout';
export default BackLayout;